import { PISANO_COLORS } from '@vision/theme';
import { SentimentKey } from '@vision/ui/interfaces';

export const SENTIMENT_LABELS: Record<SentimentKey, string> = {
  veryNegative: 'Very Negative',
  negative: 'Negative',
  neutral: 'Neutral',
  positive: 'Positive',
  veryPositive: 'Very Positive',
};

export const SENTIMENT_COLORS: Record<SentimentKey, string> = {
  veryNegative: PISANO_COLORS.red[3],
  negative: PISANO_COLORS.red[1],
  neutral: PISANO_COLORS.yellow[3],
  positive: PISANO_COLORS.green[0],
  veryPositive: `${PISANO_COLORS.green[0]}80`,
};

export const HOVERED_SENTIMENT_COLORS: Record<SentimentKey, string> = {
  veryNegative: PISANO_COLORS.red[5],
  negative: PISANO_COLORS.red[3],
  neutral: PISANO_COLORS.yellow[5],
  positive: PISANO_COLORS.green[5],
  veryPositive: PISANO_COLORS.green[7],
};

export const SENTIMENT_ORDER: SentimentKey[] = ['veryPositive', 'positive', 'neutral', 'negative', 'veryNegative'];

// Maps the raw `sentiment_label` value stored on the backend to its UI bucket.
export const SENTIMENT_MAP: Record<string, SentimentKey> = {
  negative: 'veryNegative',
  anger: 'veryNegative',
  disappointment: 'negative',
  anxiety: 'negative',
  sadness: 'negative',
  fear: 'negative',
  sarcasm: 'negative',
  expectation: 'neutral',
  mixed: 'neutral',
  neutral: 'neutral',
  happiness: 'positive',
  positive: 'positive',
  appreciation: 'veryPositive',
  recommendation: 'veryPositive',
  suggestion: 'veryPositive',
  gratitude: 'veryPositive',
};

// Inverse of SENTIMENT_MAP, derived once so the two stay in sync.
export const SENTIMENT_BUCKET_TO_LABELS: Record<SentimentKey, string[]> = Object.entries(SENTIMENT_MAP).reduce(
  (acc, [label, bucket]) => {
    acc[bucket].push(label);
    return acc;
  },
  { veryNegative: [], negative: [], neutral: [], positive: [], veryPositive: [] } as Record<SentimentKey, string[]>,
);

export const SENTIMENT_BUCKET_ALL = 'all';
